import { useCallback, useState } from 'react'

export function useErrorOnBlur(inputError: string) {
  const [isBlur, setIsBlur] = useState(false)
  const error = isBlur ? inputError : ''
  const onBlur = useCallback(() => setIsBlur(true), [setIsBlur])
  return { error, onBlur }
}
